import logo from './logo.svg';
import WeeklyCalendar from './components/WeeklyCalendar';

function App() {
    return (
        <div className="app">
            <WeeklyCalendar />
        </div>
    );
}

export default App;
